import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Card, CardContent } from '@mui/material';
import ActivityCalendar from './ActivityCalendar';
import useThemeStyles from '../../../hooks/useThemeStyles';

const WritingActivityCard = ({ activity, dailyWordGoal }) => {
  const { components } = useThemeStyles();

  const cardStyle = {
    ...components.card,
    borderRadius: '12px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  };

  return (
    <Box
      id="writing-activity-container"
      sx={{
        display: 'flex',
        flex: '0 0 auto',
        minWidth: 0,
        maxWidth: { md: '380px' },
        width: { md: '380px' },
        alignSelf: 'stretch',
      }}
    >
      <Card
        id="writing-activity-card"
        sx={{ width: '100%', display: 'flex', flexDirection: 'column', height: '100%' }}
        style={cardStyle}
      >
        <CardContent id="writing-activity-content" sx={{ padding: 3 }}>
          <Box
            id="writing-activity-header"
            sx={{ display: 'flex', alignItems: 'center', gap: 1, marginBottom: 2 }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Writing Activity
            </Typography>
          </Box>
          <ActivityCalendar activity={activity} dailyWordGoal={dailyWordGoal} />
        </CardContent>
      </Card>
    </Box>
  );
};

WritingActivityCard.propTypes = {
  activity: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string.isRequired,
      wordCount: PropTypes.number,
    })
  ).isRequired,
  dailyWordGoal: PropTypes.number.isRequired,
};

export default WritingActivityCard;
